import React, { useContext } from "react";
import SocialLinks from "./SocialLinks";
import { CompanyContext } from "../../contexts/CompanyContext";

const FooterCopyright = () => {
  const { companyName } = useContext(CompanyContext);
  const socialLinks = [
    { href: "https://www.facebook.com/", iconClass: "ri-facebook-fill" },
    { href: "https://www.instagram.com/", iconClass: "ri-instagram-fill" },
    { href: "https://twitter.com/", iconClass: "ri-twitter-fill" },
    { href: "https://www.linkedin.com/", iconClass: "ri-linkedin-fill" },
  ];
  return (
    <div className="copyright-area">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-7">
            <div className="copy-right-text">
              <p>
                All Rights Reserved by <a>{companyName}</a>
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-5">
            <SocialLinks links={socialLinks} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterCopyright;
